import { render, staticRenderFns } from "./helpAndSupport.vue?vue&type=template&id=2a26c257&"
import script from "./helpAndSupport.vue?vue&type=script&lang=js&"
export * from "./helpAndSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports